import asyncComponent from '../common/utils/async-component.js';

const Dashboard = asyncComponent(async () => import('./components/dashboard/index.js'));

export default {
  components: { main: Dashboard }
};
